import endpoints from '@/utils/constants';
import { apiHelper, authHelper } from '@/utils/helpers';

const actions = {
    saveVendorType(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('post', `${endpoints.BASE_URL}${endpoints.API.vendorTypes}`, context.state.vendorType).then((res) => {
                if (res.status === 201) {
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err)
            })
        })
    },

    getVendorTypeList(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.vendorTypes}`).then((res) => {
                if (res.status === 200) {
                    context.commit('setVendorTypeList', res.data);
                }
            }).catch(err => {
                reject(err);
            })
        })
    },

    fetchVendorType(context, vendorTypeId) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.vendorTypes}/${vendorTypeId}`).then((res) => {
                if (res.status === 200) {
                    resolve(res.data);
                }
            }).catch(err => {
                reject(err);
            })
        })
    },


    updateVendorType(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('put', `${endpoints.BASE_URL}${endpoints.API.vendorTypes}/${context.state.vendorType.vendorTypeId}`, context.state.vendorType).then((res) => {
                if (res.status === 200) {
                    context.commit('setVendorType', res.data);
                    resolve(res);
                }
            }).catch(err => {
                reject(err);
            })
        });
    },


}
export default actions;